// Идентификаторы платных услуг (window.atiUser.profile.payed_services.services[].service_id)
export const PRICE_STATISTICS_SERVICE_ID = 570; // Статистика цен на грузоперевозки

// Есть ли у фирмы лицензия «Статистика цен на грузоперевозки»
export const hasPriceStatisticsLicense = () => Boolean(
  window.atiUser?.profile?.payed_services?.services
    ?.some(service => service.service_id === PRICE_STATISTICS_SERVICE_ID),
);
